// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-link {
    border: none;
    background: transparent;
    cursor: pointer;
    width: 100%;
    text-align: left;
    color: #039be5;
}

.button-link:hover{
    text-decoration: underline;
}

button.button-link:focus {
    background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/helpers/weblinks-helper/WeblinksHelper.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".button-link {\r\n    border: none;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    text-align: left;\r\n    color: #039be5;\r\n}\r\n\r\n.button-link:hover{\r\n    text-decoration: underline;\r\n}\r\n\r\nbutton.button-link:focus {\r\n    background: transparent;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
